export enum UserAlertNotificationsFlow {
    DemoLicense = 'demoLicense',
}
